// import { take, call, put, select } from 'redux-saga/effects';

import {put, select, takeLatest} from "redux-saga/effects";
import {GET_PATIENTS} from "containers/OrderPatientSearch/constants";
import {getPatientsError, getPatientsSuccess,} from "containers/OrderPatientSearch/actions";
import {makeSelectPractice} from "containers/PracticePage/selectors";
import {authorizedRequest, HTTP_METHODS} from "utils/request";

function* getPatientsSaga({ filter }) {
  try {
    const practice = yield select(makeSelectPractice());
    const response = yield authorizedRequest(
      `/practices/${practice.id}/patients/pagination/filter?limit=3&offset=0`,
      {
        method: HTTP_METHODS.POST,
        body: {
          filter,
        },
      },
    );
    yield put(getPatientsSuccess(response.list,response.total));
  } catch (error) {
    yield put(getPatientsError(error));
  }
}
// Individual exports for testing
export default function* orderPatientSearchSaga() {
  yield takeLatest(GET_PATIENTS, getPatientsSaga);
}
